import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { IAskForQuotation, IAskForQuotationProduct, IParseProduct, IQuotationProduct, IQuoteProductData } from '../../models/quotations.models';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AppState } from 'src/app/core/app.state';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { IInventoryFilter, IProduct, IProductHandlingUnit } from 'src/app/features/produits/models/products.models';
import { Observable, of, Subscription, tap, map, first } from 'rxjs';
import { EditAndSendQuotation, EditAndSendQuotationSuccess } from '../../store/quotations.actions';
import { positiveNumberValidator, quantityValidator } from 'src/app/shared/validators/fields-validators';
import { FilterDialogComponent } from 'src/app/features/produits/components/filter-dialog/filter-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ICategory } from 'src/app/features/categories/models/categories.models';
import { CatalogProductDetailsComponent } from '../catalog-product-details/catalog-product-details.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GetCatalogProducts } from 'src/app/features/catalogs/store/catalogs.actions';
import { ICatalog } from 'src/app/features/catalogs/models/catalogs.models';
import { PricebookService } from 'src/app/features/pricebook/services/pricebook.service';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { StockFulfillmentComponent } from '../details-quotes/stock-fulfillment/stock-fulfillment.component';
import { ICurrency } from 'src/app/features/customers/models/customers.models';
import { IPriceBookViewDTO } from 'src/app/features/pricebook/models/pricebook.model';
import { handlingUnitBaseMultiplier } from 'src/app/shared/utils/handling-unit.utils';

type SortDirection = 'asc' | 'desc' | null;
type SortField = 'name' | 'price_unit' | 'discount' | 'extra_discount' | 'final_price' | 'markup' | 'quantity' | 'stock' | 'cost' | null;

@Component({
  standalone: true,
  imports: [ CatalogProductDetailsComponent, SharedModule, StockFulfillmentComponent ],
  selector: 'app-products-quote',
  templateUrl: './products-quote.component.html',
  styleUrls: ['./products-quote.component.scss']
})
export class ProductsQuoteComponent implements OnInit {
  @Input() quoteProductsData!: IQuoteProductData;
  @Input() catalogMaxExtraDiscount!: number;
  @Input() availableCurrencies: ICurrency[] = [];
  @Input() disableCurrency: boolean = false;
  @Input() channel: string = '';
  @Output() changeComponent = new EventEmitter<string>();
  @Output() updateQuoteProducts = new EventEmitter<IQuoteProductData>();
  @Output() hasChanges = new EventEmitter<boolean>();
  @Output() formValid = new EventEmitter<boolean>();

  catalog$: Observable<ICatalog | null> = this.store.select(state => state.catalogs.catalog);
  catalog: ICatalog | null = null;
  isMarginOnCost: boolean = false;

  placeholder: string = 'assets/images/placeholder.png';
  totalquantity: number = 0;
  previousValue: number = 0;
  quotationProducts: IAskForQuotationProduct[] = [];
  filteredProducts: IAskForQuotationProduct[] = [];
  baseUrl = environment.BASE_URL_API;
  products$: Observable<IProduct[]> = of([]);
  catalogProducts: IProduct[] = [];
  products: IQuotationProduct[] = [];
  brands: { id: number | null; name: string }[] = [];
  categories: { id: number; name: string }[] = [];
  quantityForm!: FormGroup;
  form!: FormGroup;
  currentFilter: IQuotationProduct[] = [];
  nameControleProduct: FormControl = new FormControl();
  isFinalQuote: boolean = false;
  subscriptions: Subscription[] = [];
  selectAll: boolean = false;
  temporaryQuoteData: IQuoteProductData | null = null;
  productsfilter: any | undefined = undefined;
  isProductsFiltered: boolean = false;
  // Sorting properties
  currentSortField: SortField = null;
  currentSortDirection: SortDirection = null;
  selectedStockFulfillmentProduct: IQuotationProduct | null = null;
  isStockFulfillmentVisible: boolean = false;
  order: any = null;
  selectedProduct: IProduct | null = null;
  isDetailsVisible = false;
  currencies: ICurrency[] = [];               
  selectedCurrency: ICurrency | null = null;  
  currencyControl: FormControl = new FormControl(null); 

  trackByProductId(_index: number, product: IQuotationProduct): number {
    return product.product_id;
  }

  /**
   * Combine catalog handling units with order-line payload so every selling unit
   * appears on the quote (catalog is the superset; order row overlays selected/enabled).
   */
  private mergeQuoteHandlingUnits(orderHus: any[] | undefined, catalogHus: any[] | undefined): any[] {
    const o = orderHus || [];
    const c = catalogHus || [];
    if (!o.length) {
      return c;
    }
    if (!c.length) {
      return o;
    }
    const byId = new Map<number, any>();
    for (const hu of c) {
      if (hu?.id != null) {
        byId.set(hu.id, { ...hu });
      }
    }
    for (const hu of o) {
      if (hu?.id == null) {
        continue;
      }
      const prev = byId.get(hu.id);
      byId.set(hu.id, prev ? { ...prev, ...hu } : { ...hu });
    }
    return Array.from(byId.values());
  }

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private fb: FormBuilder,
    private translateService: TranslateService,
    private dialog: MatDialog,
    private pricebookService: PricebookService,
    private cdr: ChangeDetectorRef,
    public featureFlags: FeatureFlagService
  ) {
    this.form = this.fb.group({
      minStock: [''],
      maxStock: [''],
      minPrice: [''],
      maxPrice: [''],
      brands: [''],
      categories: ['']
    });

    this.quantityForm = this.fb.group({
    });
   }

  ngOnInit(): void {
    this.products$ = this.store.select((state) => state.catalogs.products);

    if (!this.availableCurrencies?.find(c => c.id === this.quoteProductsData.currency?.id) && this.disableCurrency === false) {
      // Take the main currency from the catalog if current currecy is not available
      this.quoteProductsData.currency = this.availableCurrencies.find(c => c.is_main);
    }

    this.order = {
      id: this.quoteProductsData.quotation_id,
      currency: this.quoteProductsData.currency,
      channel: this.quoteProductsData.channel,
    };

    const sub1 = this.products$.subscribe((products: IProduct[]) => {
      this.catalogProducts = products;
    });


    const sub4 = this.catalog$.subscribe((catalog: ICatalog | null) => {
      this.catalog = catalog;
      // Detect if catalog uses margin_on_cost pricing rule
      this.isMarginOnCost = catalog?.overall_pricing_rule === 'margin_on_cost';
    });

    // Helper method to get cost from currency or fallback to product.cost
    const getCurrencyCost = (product: IParseProduct): number | null => {
      if (!this.quoteProductsData.currency?.id) {
        return product.cost ?? null;
      }
      // Try to get cost from currencies array if available
      const currencyData = (product as any).currencies?.find((currency: any) => currency.currency_id === this.quoteProductsData.currency?.id);
      return currencyData?.cost ?? product.cost ?? null;
    };

    
    this.products = this.quoteProductsData.products.filter((product: IParseProduct) => !product.is_buy_x_get_y_line).map((product: IParseProduct) => {
      if (!this.brands.find((brand) => brand.id === product.brand_id)) {
        if(product.brand_id === null) {
          this.brands.push({id: null, name: this.translateService.instant('quotations_and_orders.without_brand')})
        } else {
          this.brands.push({ id: product.brand_id!, name: product.brand_name! });
        }
      }
      const categories = [...this.categories, ...(product.categories || [])];

      const productCategories = Array.from(
        new Map(categories.map(category => [category.id, category])).values()
      );
      this.categories = productCategories;

      const catalogProduct = this.catalogProducts.find((catalogProduct: IProduct) => catalogProduct.id === product.id);
      const primaryWarehouse = this.primaryWarehouse(product);

      const stockReservation =
        this.isMultiWarehouseStock(product) ? (product.stock_reservation && product.stock_reservation.length > 0
          ? product.stock_reservation
          : [
              {
                id: 0,
                order_id: this.quoteProductsData.quotation_id,
                state: 'draft',
                stock_id: primaryWarehouse?.stock_id || 0,
                quantity: product.quantity,
                warehouse_id: primaryWarehouse?.warehouse_id || 0,
              },
            ])
            : [];
      
      const apiHandlingUnits = this.mergeQuoteHandlingUnits(
        (product as any).handling_units,
        catalogProduct?.handling_units
      );

      const allHandlingUnits: IProductHandlingUnit[] = apiHandlingUnits.map((hu: any) => ({
        id: hu.id,
        type_id: hu.type_id,
        name: hu.name,
        quantity: handlingUnitBaseMultiplier(hu),
        multiplier_from_base_unit: hu.multiplier_from_base_unit ?? null,
        default: hu.default || false,
        selected: hu.selected || false,
        enabled: hu.enabled !== false,
        dimenssion_string: hu.dimenssion_string || undefined
      })).sort((a, b) => (a.quantity || 0) - (b.quantity || 0));
      
      const selectedHU = allHandlingUnits.find(hu => hu.selected === true);
      let handlingUnitId = product.handling_unit_id;
      if (!handlingUnitId && selectedHU) {
        handlingUnitId = selectedHU.id;
      }
      
      const supportedHandlingUnits: IProductHandlingUnit[] = allHandlingUnits;
      
      const displayQuantity = product.quantity;
      
      return {
        product_id: product.id,
        product_template_id: product.product_template_id,
        name: product.name,
        barcode: product.barcode,
        description: product.description,
        images: product.images,
        discount: product.discount,
        initial_discount: product.discount,
        extra_discount: product.extra_discount || 0,
        max_extra_discount: catalogProduct?.max_extra_discount || 0,
        cost: getCurrencyCost(product) ?? product.cost ?? 0,
        image: product.image,
        quantity: displayQuantity,
        initial_quantity: displayQuantity,
        sku: product.sku,
        // Carried alongside sku so ProductCodeService can resolve the tenant's
        // primary code on this row (WB-7419).
        erp_id: product.erp_id,
        brand: { id: product.brand_id, name: product.brand_name },
        tags: product.tags ? product.tags.map((t: any) => t.name ?? t) : [],     
        sales_price: product.sales_price,
        stock: {
          quantity: this.getStock(product) || catalogProduct?.stock?.quantity || 0,
          reorder_point: 0,
          reorder_quantity: 0,
          can_be_sold_out_of_stock: false
        },
        price_unit: product.price_unit,
        increment: product.increment,
        max_qte: product.max_qte,
        min_qte: product.min_qte,
        checked: false,
        brand_id: product.brand_id!,
        brand_name: product.brand_name,
        categories: product.categories!,
        final_price: product.final_price!,
        is_killing_stock: false,
        killing_stock_limit: undefined,
        is_owned: product.is_owned,
        status: product.status,
        stock_by_warehouse: product.stock_by_warehouse || [],
        reserved_stock: product.reserved_stock || [],
        stock_reservation: stockReservation,
        order_line_id: product.order_line_id,
        handling_units: allHandlingUnits,
        supported_handling_units: supportedHandlingUnits,
        handling_unit_id: handlingUnitId,  // Utiliser handlingUnitId déterminé ci-dessus
        quantity_handling_unit: product.customer_order_unit?.quantity ?? product.quantity_handling_unit,
        best_deal: product.best_deal,
        best_buy_x_get_y: product.best_buy_x_get_y,
        is_buy_x_get_y_line: product.is_buy_x_get_y_line,
        currencies: (product as any).currencies || catalogProduct?.currencies || []
      } as IQuotationProduct;
    });

    this.brands.sort((first, second) => (first.name < second.name ? -1 : 1));
    this.categories.sort((first, second) => (first.name < second.name ? -1 : 1));

    const controls = Object.keys(this.quantityForm.controls);
    controls.forEach(controlName => {
      this.quantityForm.removeControl(controlName);
    });

    this.products.forEach((product: IQuotationProduct) => {
      // if(this.catalogMaxExtraDiscount > 0) {
      //   this.quantityForm.addControl(`extra_discount_${product.product_id}`, new FormControl(product.extra_discount, [Validators.required, Validators.min(0), Validators.max(product.max_extra_discount!)]));
      // }
      
      let selectedHU = product.handling_units?.find(hu => hu.selected) || null;
      
      if (!selectedHU && product.handling_unit_id) {
        selectedHU = product.handling_units?.find(hu => hu.id === product.handling_unit_id) || null;
      }

      const selectedByFlag = product.handling_units?.find(hu => hu.selected === true);
      if (selectedByFlag) {
        selectedHU = selectedByFlag;
        if (!product.handling_unit_id) {
          product.handling_unit_id = selectedByFlag.id;
        }
      }
      
      const defaultHU = selectedHU?.id || product.handling_units?.find((hu: IProductHandlingUnit) => hu.default)?.id || product.handling_units?.[0]?.id;
      
      if (!product.handling_unit_id && defaultHU) {
        product.handling_unit_id = defaultHU;
      }
      
      let initialQuantity = product.quantity;
      
      let actualSelectedHU: IProductHandlingUnit | null = selectedHU;
      if (!actualSelectedHU && product.handling_unit_id) {
        actualSelectedHU = product.handling_units?.find(hu => hu.id === product.handling_unit_id) || null;
      }
      if (!actualSelectedHU && defaultHU) {
        actualSelectedHU = product.handling_units?.find(hu => hu.id === defaultHU) || null;
      }
      
      if (product.quantity_handling_unit !== null && product.quantity_handling_unit !== undefined) {
        initialQuantity = product.quantity_handling_unit;
      } 
      else if (actualSelectedHU && handlingUnitBaseMultiplier(actualSelectedHU) > 0) {
        const mult = handlingUnitBaseMultiplier(actualSelectedHU);
        // product.quantity is in total units, convert to handling units
        if (product.quantity! < mult) {
          initialQuantity = 1;
        } else {
          initialQuantity = Math.floor(product.quantity! / mult);
        }
      }
      
      product.initial_quantity = initialQuantity;

      const quantityControl = new FormControl(
          initialQuantity,
          [Validators.required, positiveNumberValidator]
      );

      // Fix: Use base multiplier === 1 instead of type_id === 1 to identify "Unit" HU
      if (actualSelectedHU && handlingUnitBaseMultiplier(actualSelectedHU) === 1) {
        quantityControl.setValidators([Validators.required, quantityValidator(product, this.translateService)]);
      }

      this.listenForQuantityChanges(quantityControl, product);
      this.quantityForm.addControl(`quantity_${product.product_id}`, quantityControl);
      this.quantityForm.addControl(`final_price_${product.product_id}`, new FormControl(product.final_price, [Validators.required]));
      this.quantityForm.addControl(`hu_${product.product_id}`, new FormControl(defaultHU));
      this.quantityForm.get(`quantity_${product.product_id}`)?.updateValueAndValidity({ emitEvent: true });
    });

    this.applyFilter();
    this.checkForChanges();
    this.getDefaultCurrency();
    this.setSelectedCurrency(this.selectedCurrency!);

    // Subscribe to form validity changes
    const sub3 = this.quantityForm.statusChanges.subscribe(() => {
      this.formValid.emit(this.quantityForm.valid);
    });

    const sub2 = this.nameControleProduct.valueChanges.subscribe(() => this.applyFilter());

    const subCurrency = this.currencyControl.valueChanges.subscribe(value => {
        this.updateProductPricesForCurrency();
      });

    this.subscriptions.push(sub1, sub2, sub3, subCurrency);

  }

  private listenForQuantityChanges(control: FormControl, product: IQuotationProduct): void {
    control.valueChanges
        // Add takeUntil(this.destroy$) for proper cleanup
        .subscribe((newQuantity: number) => {
            // newQuantity is already the clean number value
            this.updateQuantity(newQuantity, product);
        });
}
  
  getStock(product: IQuotationProduct | IParseProduct): number {
    return typeof product.stock === 'object' ? product.stock?.quantity : product.stock || 0;
  }

  private getStateForComparison(products: IQuotationProduct[] | IParseProduct[]): string {
    return JSON.stringify(products.map(p => ({
      id: 'product_id' in p ? p.product_id : p.id,
      quantity: p.quantity,
      discount: p.discount,
      price_unit: p.price_unit
    })));
  }

  private checkForChanges() {
    const originalState = this.getStateForComparison(this.quoteProductsData.products);
    const currentState = this.getStateForComparison(this.products);
    const hasChanges = originalState !== currentState || this.products.length !== this.quoteProductsData.products.length;

    // Create updated quote data
    const updatedQuoteData = {
        ...this.quoteProductsData,
        products: this.products.map(p => {
            const handlingUnitControl = this.quantityForm.get(`hu_${p.product_id}`);
            const selectedHUFromFlag = p.handling_units?.find(hu => hu.selected);
            const handlingUnitId = handlingUnitControl?.value ?? selectedHUFromFlag?.id ?? p.handling_unit_id ?? undefined;
            
            let quantityTotal = p.quantity;
            if (
              handlingUnitId &&
              p.handling_units &&
              p.quantity_handling_unit !== null &&
              p.quantity_handling_unit !== undefined
            ) {
              const selectedHU = p.handling_units.find(hu => hu.id === handlingUnitId);
              const mult = handlingUnitBaseMultiplier(selectedHU);
              if (selectedHU && mult > 0) {
                quantityTotal = p.quantity_handling_unit * mult;
              }
            }
            
            return {
                id: p.product_id,
                product_template_id: p.product_template_id,
                name: p.name,
                quantity: quantityTotal,
                description: p.description,
                images: p.images,
                tags: p.tags,
                barcode: p.barcode,
                sales_price: p.sales_price,
                sku: p.sku,
                erp_id: p.erp_id,
                cost: p.cost,
                discount: p.discount,
                extra_discount: p.extra_discount || 0,
                price_unit: p.price_unit!,
                final_price: p.final_price,
                total: p.final_price * quantityTotal,
                image: p.image,
                increment: p.increment,
                max_qte: p.max_qte,
                min_qte: p.min_qte,
                is_killing_stock: false,
                killing_stock_limit: undefined,
                is_owned: p.is_owned,
                status: p.status,
                brand_id: p.brand_id,
                brand_name: p.brand_name,
                categories: p.categories,
                total_open_quantity: undefined,
                stock_by_warehouse: p.stock_by_warehouse || [],
                reserved_stock: p.reserved_stock || [],
                stock_reservation: p.stock_reservation || [],
                order_line_id: p.order_line_id,
                handling_units: p.handling_units || [],
                handling_unit_id: handlingUnitId,
                best_deal: p.best_deal,
                best_buy_x_get_y: p.best_buy_x_get_y,
                is_buy_x_get_y_line: p.is_buy_x_get_y_line
            };
        }),
        currency: this.selectedCurrency!
    };

    // Emit both the changes and form validity
    this.updateQuoteProducts.emit(updatedQuoteData);
    this.hasChanges.emit(hasChanges);
    this.formValid.emit(this.quantityForm.valid);
  }

  goTo(form: string) {
    // Store current state before switching to catalog view
    this.quoteProductsData.currency = this.selectedCurrency!;
    this.temporaryQuoteData = JSON.parse(JSON.stringify(this.quoteProductsData));
    const aiOrder = this.channel === 'prompt' || this.channel === 'email';
    this.changeComponent.emit(aiOrder ? 'products-from-all-products' : 'products-from-catalog');
  }

  goToAddProducts(): void {
    this.goTo('products-from-catalog');
  }

  updateQuantity(quantity: number, product: IQuotationProduct) {
    const quantityInput = quantity;
    
    const handlingUnitControl = this.quantityForm.get(`hu_${product.product_id}`);
    const handlingUnitId = handlingUnitControl?.value ?? product.handling_unit_id;
    const selectedHU = product.handling_units?.find(hu => hu.id === handlingUnitId);
    
    let quantityTotal = quantityInput;
    const mult = handlingUnitBaseMultiplier(selectedHU);
    if (selectedHU && mult > 0) {
      quantityTotal = quantityInput * mult;
    }

    product = {
      ...product,
      quantity: quantityTotal,
      quantity_handling_unit: quantityInput,
    }
    
    if (this.isMultiWarehouseStock(product)) {
      const mainWarehouse = product.stock_by_warehouse?.find((stock: any) => stock.is_primary && stock.warehouse_id !== null);

      if(!this.hasExistingStockReservationForQuantity(product, product.quantity)) {
        product = {
          ...product,
          stock_reservation: [
            {
              id: 0,
              state: 'draft',
              warehouse_id: mainWarehouse?.warehouse_id || 0,
              order_id: this.order.id,
              stock_id: mainWarehouse?.stock_id || 0,
              quantity: quantityTotal, 
            }
          ],
          reserved_stock: [
            ...(product.reserved_stock || []).filter((stock: any) => stock.order_id !== this.order.id),
            {
              stock_id: mainWarehouse?.stock_id || 0,
              quantity: quantityTotal,
              state: 'draft',
              warehouse_id: mainWarehouse?.warehouse_id || 0,
              order_id: this.order.id,
              name: mainWarehouse?.name!,
            }
          ]
        }
      }
    }

    // Update the product in both products and currentFilter arrays
    const productIndex = this.products.findIndex((p: any) => p.product_id === product.product_id);
    if (productIndex !== -1) {
      this.products[productIndex] = {
        ...this.products[productIndex],
        ...product
      };
    }

    // Update in currentFilter array
    const currentFilterIndex = this.currentFilter.findIndex((p: any) => p.product_id === product.product_id);
    if (currentFilterIndex !== -1) {
      this.currentFilter[currentFilterIndex] = {
        ...this.currentFilter[currentFilterIndex],
        ...product
      };
    }

    this.checkForChanges();
  }

  private hasExistingStockReservationForQuantity(product: IQuotationProduct, quantity: number): boolean {
    return product.stock_reservation! && product.stock_reservation.filter((stock) => stock.quantity === quantity).length > 0;
  }

  private getCurrentHandlingUnitId(product: IQuotationProduct): number | null {
    const formControlValue = this.quantityForm.get(`hu_${product.product_id}`)?.value;
    const currentHandlingUnitId = formControlValue || product.handling_unit_id;
    if (!currentHandlingUnitId) return null;
    return currentHandlingUnitId;
  }

  private getSelectedHandlingUnitById(product: IQuotationProduct, handlingUnitId: number): IProductHandlingUnit | null {
    const allHandlingUnits = product.supported_handling_units || product.handling_units || [];
    return allHandlingUnits.find((hu: IProductHandlingUnit) => hu.id === handlingUnitId) || null;
  }

  /**
   * Wrapper for {@link handlingUnitBaseMultiplier} so the template can show the
   * per-selling-unit factor (e.g. “0.25 units”) without importing the util in HTML.
   *
   * Selling units come from `IProductHandlingUnit` on the quote row (catalog API).
   * The value must stay aligned with Odoo `sale.order.line` `product_uom_qty`
   * conversion on the server.
   */
  getHandlingUnitBaseMultiplier(hu: IProductHandlingUnit | null | undefined): number {
    return handlingUnitBaseMultiplier(hu);
  }

  onHandlingUnitChange(event: any, product: IQuotationProduct) {
    const handlingUnitId = event.value ?? event.target?.value;
    const numericNewHuId = typeof handlingUnitId === 'number' ? handlingUnitId : +handlingUnitId;

    const previousTotalUnits = product.quantity || 0;
    const prevHuId = product.handling_unit_id ?? null;
    const prevHU = product.handling_units?.find(hu => hu.id === prevHuId);
    const prevSize = this.getHandlingUnitBaseMultiplier(prevHU);

    const prevInputControl = this.quantityForm.get(`quantity_${product.product_id}`);
    let prevInputCount = prevInputControl?.value;
    if (prevInputCount === null || prevInputCount === undefined || prevInputCount === '') {
      if (product.quantity_handling_unit !== undefined && product.quantity_handling_unit !== null) {
        prevInputCount = product.quantity_handling_unit;
      } else {
        // Calculate from total units
        prevInputCount = Math.floor((product.quantity ?? 0) / prevSize);
      }
    } else {
      // ensure numeric
      prevInputCount = Number(prevInputCount) || 0;
    }

    // Find the new HU
    const newHU = product.handling_units?.find(hu => hu.id === numericNewHuId);
    const newSize = this.getHandlingUnitBaseMultiplier(newHU);
    const isUnitHU = newHU && this.getHandlingUnitBaseMultiplier(newHU) === 1;
    let newHUCount: number;
    let newTotalUnits: number;

    if (prevInputCount > 0 && newSize > 0) {
      newHUCount = prevInputCount;
      newTotalUnits = prevInputCount * newSize;
    } else if (previousTotalUnits > 0 && newSize > 0) {
      newHUCount = Math.max(1, Math.ceil(previousTotalUnits / newSize));
      newTotalUnits = newHUCount * newSize;
    } else {
      newHUCount = 0;
      newTotalUnits = 0;
    }

    // When switching to Unit HU with increment rules, round to next valid multiple
    if (isUnitHU && product.increment && product.increment > 1 && newHUCount > 0) {
      const remainder = newHUCount % product.increment;
      if (remainder !== 0) {
        newHUCount = Math.ceil(newHUCount / product.increment) * product.increment;
        newTotalUnits = newHUCount * newSize;
      }
    }

    const newHuControl = this.quantityForm.get(`hu_${product.product_id}`);
    if (newHuControl) {
      newHuControl.setValue(numericNewHuId, { emitEvent: true });
    }

    if (prevInputControl) {
      prevInputControl.setValue(newHUCount, { emitEvent: false });
    }

    // update product model fields
    product.handling_unit_id = numericNewHuId;
    product.quantity_handling_unit = newHUCount;
    product.quantity = newTotalUnits;

    const quantityControl = this.quantityForm.get(`quantity_${product.product_id}`);

    // Fix: Use quantity === 1 instead of type_id === 1 to identify "Unit" HU
    if(isUnitHU) {
      quantityControl?.setValidators([Validators.required, quantityValidator(product, this.translateService)]);
    } else {
      quantityControl?.setValidators([Validators.required, positiveNumberValidator]);
    }

    quantityControl?.updateValueAndValidity({ emitEvent: true }); 

    this.checkForChanges();
  }

  getTotalUnits(product: IQuotationProduct): number | null {
    const currentHUId = this.getCurrentHandlingUnitId(product);
    if (!currentHUId || !product.handling_units?.length) {
      return null;
    }
    
    const selectedHU = this.getSelectedHandlingUnitById(product, currentHUId);
    const mult = this.getHandlingUnitBaseMultiplier(selectedHU);
    if (mult > 0) {
      if (product.quantity_handling_unit !== null && product.quantity_handling_unit !== undefined) {
        const totalUnits = product.quantity_handling_unit * mult;
        return totalUnits;
      }
      return product.quantity;
    }
    return null;
  }


  getTotalAmount(product: IQuotationProduct): number {
    const totalUnits = this.getTotalUnits(product);
    const finalPrice = this.getCurrencyPrice(product, 'final_price') ?? product.final_price;
    if (totalUnits && finalPrice) {
      return finalPrice * totalUnits;
    }
    return finalPrice ? finalPrice * product.quantity : 0;
  }

  getSelectedHandlingUnit(product: IQuotationProduct): IProductHandlingUnit | null {
    const currentHUId = this.getCurrentHandlingUnitId(product);
    if (!currentHUId) return null;
    return this.getSelectedHandlingUnitById(product, currentHUId);
  }

  /**
   * Returns the quantity control error message for display (min, max, increment, required, positive number).
   * Matches catalog validation messaging without +/- controls.
   */
  getQuantityErrorMessage(product: IQuotationProduct): string | null {
    const control = this.quantityForm.get(`quantity_${product.product_id}`);
    const errors = control?.errors;
    if (!errors || (!control?.touched && !control?.dirty)) return null;
    if (errors['required']) return this.translateService.instant('validation.required');
    if (errors['positiveNumber']) return this.translateService.instant('validation.positive_number');
    // quantityValidator returns translated message as value
    if (errors['quantityInvalid']) return errors['quantityInvalid'] as string;
    if (errors['quantityMin']) return errors['quantityMin'] as string;
    if (errors['quantityMax']) return errors['quantityMax'] as string;
    if (errors['quantityIncrement']) return errors['quantityIncrement'] as string;
    return null;
  }

  isHandlingUnitDifferentFromDefault(product: IQuotationProduct): boolean {
    const currentHUId = this.getCurrentHandlingUnitId(product);
    if (!currentHUId) return false;
    
    const selectedHU = this.getSelectedHandlingUnitById(product, currentHUId);
    if (!selectedHU) return false;
    
    const catalogDefaultHU = this.quoteProductsData.catalog_default_handling_unit;
    
    if (catalogDefaultHU) {
      const catalogDefaultTypeId = typeof catalogDefaultHU.id === 'number' ? catalogDefaultHU.id : +catalogDefaultHU.id;
      const selectedTypeId = selectedHU.type_id;
      
      if (selectedTypeId !== undefined && selectedTypeId !== null) {
        return selectedTypeId !== catalogDefaultTypeId;
      }
      return currentHUId !== catalogDefaultTypeId;
    }
    
    // Fallback to product's default handling unit
    const allHandlingUnits = product.supported_handling_units || product.handling_units || [];
    const defaultHU = allHandlingUnits.find((hu: IProductHandlingUnit) => hu.default);
    
    if (!defaultHU) return false;
    
    const defaultHUId = typeof defaultHU.id === 'number' ? defaultHU.id : +defaultHU.id;
    return currentHUId !== defaultHUId;
  }

  updateListQuantity(event: { productId: number; quantity: number }) {
    const productIndex = this.products.findIndex(p => p.product_id === event.productId);
    if (productIndex > -1) {
      const updatedProduct = { ...this.products[productIndex], quantity: event.quantity };
      this.products = [
        ...this.products.slice(0, productIndex),
        updatedProduct,
        ...this.products.slice(productIndex + 1)
      ];

      const quoteIndex = this.quoteProductsData.products.findIndex(p => p.id === event.productId);
      if (quoteIndex > -1) {
        this.quoteProductsData.products[quoteIndex].quantity = event.quantity;
      }

      const controlName = 'quantity_' + event.productId;
      if (this.quantityForm.contains(controlName)) {
        this.quantityForm.get(controlName)?.setValue(event.quantity, { emitEvent: true });
      }
    }
  }

  updateDiscount(event: any, product: IQuotationProduct) {
    let discount = event.target.value
    if (discount.endsWith(',') || discount.endsWith('.')) return;
    const [_, dec] = discount.split(/[,.]/)
    if (dec && dec.length > 2) {
      discount = Number((+discount).toFixed(2))
      event.target.value = discount
    }
    discount = Number(discount)
    
    if (this.isMarginOnCost) {
      if (discount < -100) {
        discount = -100;
        event.target.value = discount;
      }
    } else {
      if (discount < 0 || discount > 100) {
        discount = Math.min(Math.max(discount, 0), 100);
        event.target.value = discount
      }
    }

    product.discount = discount;
    const newFinalPrice = this.getFinalPrice(product);
    product.final_price = newFinalPrice;

    if(newFinalPrice) {
      const controlName = 'final_price_' + product.product_id;
      const control = this.quantityForm.get(controlName);
      control?.setValue(newFinalPrice, { emitEvent: false });
    }
    this.checkForChanges();
  }

  // updateExtraDiscount(event: any, product: IQuotationProduct) {
    
  // }

updateFinalPrice(event: any, product: IQuotationProduct) {
  let finalPrice = event.target.value;
  const key = event.data;

  if ([',', '.'].includes(key)) {
    return;
  }

  finalPrice = Number(finalPrice);

  // Use currency-specific sales price
  const currencySalesPrice = this.getCurrencyPrice(product, 'sales_price');
  const priceUnit = Number(currencySalesPrice ?? product.price_unit);

  if (this.isMarginOnCost) {
    if (finalPrice <= 0) {
      event.target.value = 0;
      product.final_price = 0;
      product.discount = product.cost && product.cost > 0 ? -100 : 0;
      this.checkForChanges();
      return;
    }

    product.final_price = finalPrice;

    if (product.cost && product.cost > 0) {
      let calculatedMargin = Number(
        (((finalPrice - product.cost) / product.cost) * 100).toFixed(2)
      );

      if (calculatedMargin < -100) {
        calculatedMargin = -100;
        product.final_price = product.cost * (1 + calculatedMargin / 100);
        event.target.value = product.final_price;
      }

      product.discount = calculatedMargin;
    } else {
      product.discount = 0;
    }
  }

  else {
    if (finalPrice < 0) {
      event.target.value = 0;
      product.final_price = 0;
      product.discount = 100;
      this.checkForChanges();
      return;
    }

    if (finalPrice > priceUnit && priceUnit > 0) {
      event.target.value = priceUnit;
      product.final_price = priceUnit;
      product.discount = 0;
      this.checkForChanges();
      return;
    }

    product.final_price = finalPrice;
    product.discount = priceUnit
      ? Number(100 - (finalPrice * 100) / priceUnit)
      : 0;
  }

  this.checkForChanges();
}

getFinalPrice(product: IQuotationProduct): number {
  if (this.isMarginOnCost && product.cost && product.cost > 0) {
    return product.cost * (1 + (product.discount / 100));
  }

  const salesPrice =
    this.getCurrencyPrice(product, 'sales_price') ?? product.price_unit;

  if (!salesPrice) {
    return 0;
  }

  return product.discount
    ? salesPrice * (1 - (product.discount / 100))
    : salesPrice;
}

  checkAllProducts(event: any) {
    const checked = event.checked;
    if(checked) {
      this.currentFilter.forEach((product: IQuotationProduct) => {
        if(product.checked) return;
        if ((((this.getStock(product) >= product.min_qte!) && product.is_owned) || !product.is_owned) && product.status !== 'Draft') {
          product.quantity = product.initial_quantity!;
          this.quantityForm.get(`quantity_${product.product_id}`)?.setValue(product.initial_quantity);
          product.checked = checked;
        }
      });
    } else {
      this.products.forEach((product: IQuotationProduct) => {
        this.quantityForm.get(`quantity_${product.product_id}`)?.setValue(product.min_qte);
        product.checked = checked;
      });
    }
  }

  getDefaultCurrency(): boolean | void {
    let defaultCurrencyId: number | null = null;

    if (this.disableCurrency) {
      defaultCurrencyId = this.quoteProductsData.currency?.id || null;
      this.currencyControl.setValue(defaultCurrencyId, { emitEvent: false });
      this.selectedCurrency = this.quoteProductsData.currency || null;
      this.availableCurrencies = [this.selectedCurrency!];
      return;
    }
  
    if (  
      this.quoteProductsData.currency &&
      this.availableCurrencies.some(c => c.id === this.quoteProductsData.currency!.id)
    ) {
      defaultCurrencyId = this.quoteProductsData.currency!.id;
    } else {
      defaultCurrencyId = this.availableCurrencies.find(c => c.is_main)?.id ?? null;
    }

    if (defaultCurrencyId) {
      this.currencyControl.setValue(defaultCurrencyId, { emitEvent: false });
      this.selectedCurrency = this.availableCurrencies.find(c => c.id === defaultCurrencyId) || null;
    }
  }

  setSelectedCurrency(selectedCurrency: ICurrency) {
    if (!selectedCurrency) return;
    this.selectedCurrency = selectedCurrency;
    this.quoteProductsData.currency = {

      id: selectedCurrency.id,
      symbol: selectedCurrency.symbol,
      name: selectedCurrency.name
    } as any;

    this.currencyControl.setValue(selectedCurrency.id, { emitEvent: false });
    this.updateProductPricesForCurrency();
  }

  onCurrencyChange(currencyId: number) {
    const selected = this.availableCurrencies.find(c => c.id === currencyId);
    this.setSelectedCurrency(selected!);
  }

  private getPricesFromCurrency(product: IProduct, currencyId: number): { sales_price: number | null; final_price: number; cost: number | null } {
    if (product && (product as any).currencies && (product as any).currencies.length > 0) {
      const currencyData = (product as any).currencies.find((currency: any) => currency.currency_id === currencyId);
      if (currencyData) {
        return {
          sales_price: currencyData.sales_price ?? null,
          final_price: currencyData.final_price ?? (product as any).final_price ?? 0,
          cost: currencyData.cost ?? (product as any).cost ?? null
        };
      }
    }
    return {
      sales_price: (product as any).sales_price ?? 0,
      final_price: (product as any).final_price ?? 0,
      cost: (product as any).cost ?? null
    };
  }

  // Get currency-specific price for display in template
  getCurrencyPrice(product: IQuotationProduct, priceType: 'sales_price' | 'final_price'): number | null {
    const selectedCurrencyId = this.currencyControl.value;
    if (!selectedCurrencyId) {
      return priceType === 'sales_price' ? product.price_unit : product.final_price;
    }

    // Try to get from product currencies
    const currencies = (product as any).currencies;
    if (currencies && currencies.length > 0) {
      const currencyData = currencies.find((c: any) => c.currency_id === selectedCurrencyId);
      if (currencyData) {
        return currencyData[priceType] ?? null;
      }
    }

    // Fallback to catalog products
    const catalogProduct = this.catalogProducts.find(p => p.id === product.product_id);
    if (catalogProduct?.currencies && catalogProduct.currencies.length > 0) {
      const currencyData = catalogProduct.currencies.find(c => c.currency_id === selectedCurrencyId);
      if (currencyData) {
        return priceType === 'sales_price' ? currencyData.sales_price ?? null : currencyData.final_price ?? null;
      }
    }

    // Final fallback to product's direct values
    return priceType === 'sales_price' ? product.price_unit : product.final_price;
  }

  getCurrencySymbol(): string {
    return this.selectedCurrency?.symbol || '';
  }

  private updateProductPricesForCurrency(): void {
    const selectedCurrencyId = this.currencyControl.value;
    if (!selectedCurrencyId || this.products.length === 0) return;

    this.products$.pipe(first()).subscribe((catalogProducts: IProduct[]) => {
      this.products.forEach((quotationProduct: IQuotationProduct) => {

        const originalProduct = catalogProducts.find(
          p => p.id === quotationProduct.product_id
        );

        const quotationCurrencies = (quotationProduct as any).currencies;
        const catalogCurrencies = originalProduct?.currencies;
        const currencies =
          quotationCurrencies && quotationCurrencies.length > 0
            ? quotationCurrencies
            : (catalogCurrencies || []);

        let productPrices: any = null;

        if (originalProduct) {
          productPrices = this.getPricesFromCurrency(
            originalProduct,
            selectedCurrencyId
          );
        }

        if (!productPrices && currencies.length > 0) {
          productPrices = currencies.find(
            (c: any) => c.currency_id === selectedCurrencyId
          );
        }

        if (!productPrices) return;

        if (productPrices.cost !== null && productPrices.cost !== undefined) {
          quotationProduct.cost = productPrices.cost;
        }

        const newPriceUnit =
          productPrices.sales_price ?? quotationProduct.price_unit;

        const orderDiscount =
          (quotationProduct as any).initial_discount !== undefined &&
          (quotationProduct as any).initial_discount !== null
            ? (quotationProduct as any).initial_discount
            : quotationProduct.discount;

        let newFinalPrice: number;

        if (productPrices.final_price && productPrices.final_price > 0) {
          newFinalPrice = productPrices.final_price;
        } else if (this.isMarginOnCost && productPrices.cost && productPrices.cost > 0) {
          const margin = orderDiscount || 0;
          newFinalPrice = productPrices.cost * (1 + margin / 100);
        } else if (productPrices.sales_price) {
          const discount = orderDiscount || 0;
          newFinalPrice = productPrices.sales_price * (1 - discount / 100);
        } else {
          newFinalPrice = quotationProduct.final_price ?? 0;
        }

        quotationProduct.price_unit = newPriceUnit;
        quotationProduct.final_price = newFinalPrice;
        quotationProduct.discount = orderDiscount;

        const finalPriceControlName = `final_price_${quotationProduct.product_id}`;
        if (this.quantityForm.contains(finalPriceControlName)) {
          this.quantityForm
            .get(finalPriceControlName)
            ?.setValue(newFinalPrice, { emitEvent: false });
        }
      });

      this.checkAllProducts({ checked: true });
      this.quantityForm.updateValueAndValidity();
      this.applyFilter();
      this.checkForChanges();
      this.cdr.detectChanges();
    });
  }

  isAllChecked() {
    return (
      this.currentFilter.length > 0 &&
      this.currentFilter.every(
        (product) =>
          product.checked ||
          (product.status === 'Draft' || ((this.getStock(product) < product.min_qte!) && product.is_owned))
      )
    );
  }

  productsSelected(): number {
    return this.products.filter((product: IQuotationProduct) => product.checked).length;
  }

  allProductsDisable(): boolean {
    return this.currentFilter.every((product: IQuotationProduct) => (product.status === 'Draft' || this.getStock(product) < product.min_qte!));
  }

  totalQuantity(): number {
    return this.products.reduce((acc, product) => {
      return acc + product.quantity;
    }, 0);
  }

  totalPrice(): number {
    return this.products.reduce((acc, product) => {
      const quantity = this.getTotalUnits(product) || product.quantity;
      const finalPrice = this.getCurrencyPrice(product, 'final_price');
      const salesPrice = this.getCurrencyPrice(product, 'sales_price');
      return acc + (finalPrice ? quantity * finalPrice : (quantity * (salesPrice! * (1 - product.discount / 100))));
    }, 0);
  }

  checkProduct(product: IQuotationProduct, event: any) {
    const checked = event.target.checked;
    product.checked = checked;

    // Update selectAll state
    this.selectAll = this.currentFilter.every(p => p.checked);
  }

  setFilter() {
    const dialogRef = this.dialog.open(FilterDialogComponent, {
      minWidth: '650px',
      width: '90vw',
      height: '80vh',
      data: {
        filter: this.productsfilter,
        isQuoteProducts: true
      }
    });

    // Handle selected products filter locally
    dialogRef.afterClosed().subscribe((filter: IInventoryFilter) => {
      if(filter) {
        this.isProductsFiltered = this.isFiltered(filter);
        this.applyFilter();
      }
    })
  }

  isFiltered(filter: any) {
    if(filter) {
      const parsedFilter = {...filter.inventoryFilter, ...filter.productsInfoFilter, ...filter.organizeFilter};
      this.productsfilter = parsedFilter;

      const isFiltered = !!(
        (parsedFilter.name && parsedFilter.name !== "") ||
        (parsedFilter.sku && parsedFilter.sku !== "") ||
        (parsedFilter.barcode && parsedFilter.barcode !== "") ||
        (parsedFilter.brands && parsedFilter.brands.length > 0) ||
        parsedFilter.status ||
        parsedFilter.has_variants ||
        parsedFilter.sales_price_min != null ||
        parsedFilter.sales_price_max != null ||
        parsedFilter.cost_min != null ||
        parsedFilter.cost_max != null ||
        parsedFilter.quantity_min != null ||
        parsedFilter.quantity_max != null ||
        parsedFilter.reorder_point_min != null ||
        parsedFilter.reorder_point_max != null ||
        (parsedFilter.categories && parsedFilter.categories.length > 0) ||
        (parsedFilter.tags && parsedFilter.tags.length > 0) ||
        parsedFilter.has_catalogs ||
        parsedFilter.number_of_catalogs != null
      );

      return isFiltered
    }

    return false;
  }

  applyFilter(): void {
    const filter = this.productsfilter;

    // First apply name/SKU filter
    let filteredProducts = this.products.filter(product => {
      const nameOrSkuMatches = !this.nameControleProduct.value ||
        product.name?.toLowerCase().includes(this.nameControleProduct.value?.trim().toLowerCase()) ||
        product.sku?.toLowerCase().includes(this.nameControleProduct.value?.trim().toLowerCase());
      return nameOrSkuMatches;
    });

    // Then apply advanced filters if they exist
    if (filter) {
      filteredProducts = filteredProducts.filter(product =>
        (filter.name === undefined || product.name?.toLowerCase().includes(filter.name.toLowerCase())) &&
        (filter.sku === undefined || product.sku?.toLowerCase().includes(filter.sku.toLowerCase())) &&
        (filter.brands === undefined || filter.brands.length === 0 || filter.brands.some((brand: any) => brand.id === product.brand_id)) &&
        (filter.status === undefined || product.status === filter.status) &&
        (filter.sales_price_min === undefined || product.price_unit! >= filter.sales_price_min) &&
        (filter.sales_price_max === undefined || product.price_unit! <= filter.sales_price_max) &&
        (filter.cost_min === undefined || product.cost >= filter.cost_min) &&
        (filter.cost_max === undefined || product.cost <= filter.cost_max) &&
        (filter.quantity_min === undefined || this.getStock(product) >= filter.quantity_min) &&
        (filter.quantity_max === undefined || this.getStock(product) <= filter.quantity_max) &&
        (filter.reorder_point_min === undefined || (product.stock?.reorder_point ?? 0) >= filter.reorder_point_min) &&
        (filter.reorder_point_max === undefined || (product.stock?.reorder_point ?? 0) <= filter.reorder_point_max) &&
        (filter.categories === undefined || filter.categories.length === 0 || product.categories?.some(cat => filter.categories.map((category: ICategory) => category.id).includes(cat.id)))
      );
    }

    // Update currentFilter with the filtered results
    this.currentFilter = filteredProducts;
    this.applySorting();
  }

  clearFilter() {
    this.isProductsFiltered = false
    this.productsfilter = undefined
    this.applyFilter()
  }

  sort(field: SortField): void {
    if (this.currentSortField === field) {
      // Toggle direction if clicking the same field
      this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Set new field and default to ascending
      this.currentSortField = field;
      this.currentSortDirection = 'asc';
    }
    this.applySorting();
  }

  private applySorting(): void {
    if (!this.currentSortField || !this.currentSortDirection) {
      return;
    }

    this.currentFilter.sort((a, b) => {
      let valueA: any;
      let valueB: any;

      switch (this.currentSortField) {
        case 'name':
          valueA = a.name.toLowerCase();
          valueB = b.name.toLowerCase();
          break;
        case 'price_unit':
          valueA = a.price_unit || 0;
          valueB = b.price_unit || 0;
          break;
        case 'cost':
          valueA = a.cost || 0;
          valueB = b.cost || 0;
          break;
        case 'discount':
          valueA = a.discount || 0;
          valueB = b.discount || 0;
          break;
        case 'final_price':
          valueA = a.final_price || 0;
          valueB = b.final_price || 0;
          break;
        case 'markup':
          valueA = (a.final_price - a.cost) || 0;
          valueB = (b.final_price - b.cost) || 0;
          break;
        case 'quantity':
          valueA = a.quantity || 0;
          valueB = b.quantity || 0;
          break;
        case 'stock':
          // Special handling for stock sorting
          if (a.is_owned !== b.is_owned) {
            // If one is owned and the other isn't, owned products go to the bottom in ascending order
            return this.currentSortDirection === 'asc'
              ? (a.is_owned ? 1 : -1)  // owned products go to bottom in ascending
              : (a.is_owned ? -1 : 1); // owned products go to top in descending
          }
          // If both have same ownership status, sort by stock quantity
          valueA = this.getStock(a) || 0;
          valueB = this.getStock(b) || 0;
          break;
        default:
          return 0;
      }

      if (valueA < valueB) {
        return this.currentSortDirection === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.currentSortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  isKillingStock(product: IQuotationProduct): boolean {
    if(product.checked && product.killing_stock_limit && product.killing_stock_limit > 0 && product.initial_quantity) {
      const is_killing_stock: boolean = (product.initial_quantity - product.quantity) < product.killing_stock_limit;
      return is_killing_stock;
    }
    else return false;
  }
  exceededStock(product: IQuotationProduct): number {
    if(product.checked && product.killing_stock_limit && product.initial_quantity ) {
      return product.killing_stock_limit - (product.initial_quantity - product.quantity);
    }
    else return 0;
  }

  isStockAlert(product: IQuotationProduct): boolean {
    if (this.isMarginOnCost && (!product.cost || product.cost === 0)) {
      return true;
    }
    if(product.is_owned)
    {
      if(product.killing_stock_limit! + product.initial_quantity! - product.quantity < 0 || product.quantity >= this.getStock(product)) return true;
    }
    return false;
  }
  
  alertType(product: IQuotationProduct): string {
    if (this.isMarginOnCost && (!product.cost || product.cost === 0)) {
      return 'alert_div_warning';
    }
    if(product.quantity > this.getStock(product)) return 'alert_div_danger';
    if(product.killing_stock_limit! + product.initial_quantity! - product.quantity < 0 || product.quantity == this.getStock(product)) return 'alert_div_warning';
    return '';
  }

  alertMessage(product: IQuotationProduct): string {
    if (this.isMarginOnCost && (!product.cost || product.cost === 0)) {
      return 'quotations_and_orders.cost_missing_single';
    }
    if(product.quantity > this.getStock(product)) return 'quotations_and_orders.requested_quantity_exceeds_available_stock';
    if(product.killing_stock_limit! + product.initial_quantity! - product.quantity < 0) return 'quotations_and_orders.insufficient_stock_combined_orders';
    if(product.quantity == this.getStock(product)) return 'quotations_and_orders.order_deplete_available_stock';
    return '';
  }

  SendQuotation(): void | boolean {
    if(this.quantityForm.invalid || this.products.filter(product => product.checked).length === 0) {
      this.quantityForm.markAllAsTouched();
      return false;
    }

    const products: IAskForQuotationProduct[] = this.products.map((product: IQuotationProduct) => {
      let quantity = product.quantity;
      
      const handlingUnitControl = this.quantityForm.get(`hu_${product.product_id}`);
      const selectedHUFromFlag = product.handling_units?.find(hu => hu.selected);
      const handlingUnitId = handlingUnitControl?.value ?? selectedHUFromFlag?.id ?? product.handling_unit_id ?? undefined;
      
      if (product.quantity_handling_unit !== null && product.quantity_handling_unit !== undefined && handlingUnitId && product.handling_units) {
        const allHandlingUnits = product.supported_handling_units || product.handling_units || [];
        const selectedHU = allHandlingUnits.find((hu: IProductHandlingUnit) => hu.id === handlingUnitId);
        const mult = this.getHandlingUnitBaseMultiplier(selectedHU);
        if (selectedHU && mult > 0) {
          quantity = product.quantity_handling_unit * mult;
        }
      }
      
      const stock_reservation = this.isMultiWarehouseStock(product) 
        ? (
          product.stock_reservation ||
          product.stock_by_warehouse
            ?.filter((stock: any) => stock.is_primary && stock.warehouse_id !== null)
            .map((stock: any) => ({
              warehouse_id: stock.warehouse_id,
              quantity: quantity,
            })) ||
          []
        )
        : [];
      return {
        product_id: product.product_id,
        name: product.name,
        quantity: quantity,
        handling_unit_id: handlingUnitId,
        discount: product.discount,
        increment: product.increment,
        min_qte: product.min_qte,
        max_qte: product.max_qte,
        sku: product.sku,
        price_unit: product.price_unit,
        total_discount: product.discount,
        final_price: product.final_price,
        stock_reservation: stock_reservation
      }
    });

    const payload: IAskForQuotation = {
      pricelist_id: this.quoteProductsData.pricelist_id,
      is_final: this.isFinalQuote,
      products: products
    }

    this.store.dispatch(EditAndSendQuotation({ id: this.quoteProductsData.quotation_id!, quotation: payload }));
  }

  ngOnDestory() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  toggleSelectAll(): void {
    this.selectAll = !this.selectAll;
    this.currentFilter.forEach(product => {
      product.checked = this.selectAll;
    });
  }

  deleteSelectedProducts(): void {
    // Get IDs of selected products
    const selectedProductIds = this.products
      .filter(product => product.checked)
      .map(product => product.product_id);

    if (selectedProductIds.length === 0) return;

    // Update quoteProductsData by filtering out selected products
    const updatedProducts = this.quoteProductsData.products.filter(
      product => !selectedProductIds.includes(product.id)
    );

    // remove the form controls for the selected products
    selectedProductIds.forEach(productId => {
      this.quantityForm.removeControl(`quantity_${productId}`);
      this.quantityForm.removeControl(`final_price_${productId}`);
    });

    const updatedQuoteData = {
      ...this.quoteProductsData,
      products: updatedProducts,
      currency: this.selectedCurrency!
    };

    // Emit the updated quote data
    this.updateQuoteProducts.emit(updatedQuoteData);

    // Update local products array and filter
    this.products = this.products.filter(product => !product.checked);
    this.currentFilter = this.currentFilter.filter(product => !product.checked);
    this.selectAll = false;
    this.checkForChanges();
  }

  getSelectedProductsCount(): number {
    return this.products.filter(product => product.checked).length;
  }

  showStockFulfillment(product: IQuotationProduct) {
    this.selectedStockFulfillmentProduct = product;
    this.isStockFulfillmentVisible = true;
  }

  closeStockFulfillment() {
    this.isStockFulfillmentVisible = false;
    this.selectedStockFulfillmentProduct = null;
  }

  updateReservation(product: any) {
    // Find the original product to compare values
    const originalProduct = this.products.find((p: IQuotationProduct) => p.product_id === product.product_id);
    
    // Update product arrays
    this.products = this.products.map((p: IQuotationProduct) =>
      p.product_id === product.product_id
        ? product
        : {
            ...p,
            stock_reservation:
              p.stock_reservation ||
              p.stock_by_warehouse
                ?.filter((stock: any) => stock.is_primary && stock.warehouse_id !== null)
                .map((stock: any) => ({
                  warehouse_id: stock.warehouse_id,
                  quantity: p.quantity,
                })) ||
              [],
          }
    );
    
    this.currentFilter = this.currentFilter.map((p: IQuotationProduct) =>
      p.product_id === product.product_id
        ? product
        : {
            ...p,
            stock_reservation:
              p.stock_reservation ||
              p.stock_by_warehouse
                ?.filter((stock: any) => stock.is_primary && stock.warehouse_id !== null)
                .map((stock: any) => ({
                  warehouse_id: stock.warehouse_id,
                  quantity: p.quantity,
                })) ||
              [],
          }
    );

    // Update form controls to reflect the new values
    if (originalProduct) {
      const productId = product.product_id;

      // Update quantity control if it changed
      if (product.quantity !== undefined && product.quantity !== originalProduct.quantity) {
        const quantityControl = this.quantityForm.get(`quantity_${productId}`);
        if (quantityControl) {
          quantityControl.setValue(product.quantity, { emitEvent: false });
        }
      }

      // Update quantity_handling_unit control if it changed
      if (product.handling_unit !== undefined && product.handling_unit.id !== originalProduct.handling_unit_id) {
        const quantityHandlingUnitControl = this.quantityForm.get(`hu_${productId}`);
        if (quantityHandlingUnitControl) {
          quantityHandlingUnitControl.setValue(product.handling_unit.id, { emitEvent: false });
        }
      }

      // Update final_price control if it changed
      if (product.final_price !== undefined && product.final_price !== originalProduct.final_price) {
        const finalPriceControl = this.quantityForm.get(`final_price_${productId}`);
        if (finalPriceControl) {
          finalPriceControl.setValue(product.final_price, { emitEvent: false });
        }
      }

      // Update handling unit control if it changed
      if (product.handling_unit_id !== undefined && product.handling_unit_id !== originalProduct.handling_unit_id) {
        const huControl = this.quantityForm.get(`hu_${productId}`);
        if (huControl && product.handling_unit_id) {
          huControl.setValue(product.handling_unit_id, { emitEvent: false });
        }
      }
    }

    this.checkForChanges();
  }
  
  sumAvailableQuantity(product: IQuotationProduct): number {
    return product.stock_by_warehouse?.reduce((acc, stock) => acc + stock.available_quantity, 0) || 0;
  }

  reservedQuantity(product: IQuotationProduct): number {
    return (
      (product.reserved_stock || [])?.reduce(
        (sum: number, reservedStock: any) =>
          sum + (reservedStock.state == 'reserved' && reservedStock.order_id === this.order.id ? reservedStock.quantity : 0),
        0
      ) || 0
    );
  }

  outOfStock(product: IQuotationProduct): boolean {
    return this.stockQuantity(product) < product.quantity;
  }

  unreservedQuantityOnWarehouse(product: IQuotationProduct, warehouseId: number): number {
    return (
      (product.reserved_stock || [])?.find(
        (reservedStock) =>
          reservedStock.warehouse_id === warehouseId && reservedStock.order_id === this.order.id && reservedStock.state !== 'reserved'
      )?.quantity || 0
    );
  }

  primaryWarehouse(product: any): any | undefined {
    return product.stock_by_warehouse?.find((stock: any) => stock.is_primary && stock.warehouse_id !== null);
  }

  outOfStockMainWarehouse(product: any): boolean {
    const mainWarehouse = this.primaryWarehouse(product);
    const unreservedQuantityOnMainWarehouse = this.unreservedQuantityOnWarehouse(product, mainWarehouse?.warehouse_id || 0);
    return (mainWarehouse?.available_quantity || 0) < unreservedQuantityOnMainWarehouse;
  }

  hasErrorStock(product: IQuotationProduct): boolean {
    if (this.isMultiWarehouseStock(product)) {
      return this.outOfStock(product) || this.outOfStockMainWarehouse(product);
    } else {
      return product.quantity > this.getStock(product);
    }
  }
  
  isMultiWarehouseStock(product: any): boolean {
    return (product.stock_by_warehouse && product.stock_by_warehouse.filter((stock: any) => stock.warehouse_id !== null).length > 0) || false;
  }
  
  draftQuantity(product: IQuotationProduct): number {
    return (
      (product.reserved_stock || [])?.reduce(
        (sum: number, reservedStock: any) =>
          sum + (reservedStock.state == 'draft' && reservedStock.order_id === this.order.id ? reservedStock.quantity : 0),
        0
      ) || 0
    );
  }
  
  stockQuantity(product: IQuotationProduct): number {
    return this.isMultiWarehouseStock(product) ? this.sumAvailableQuantity(product) : this.getStock(product);
  }
  
  showDetails(product: any): void {
    this.selectedProduct = product;   
    this.isDetailsVisible = true;
    }

  closeDetails(): void {
    this.isDetailsVisible = false;
    this.selectedProduct = null;
  }

  getGifts() {
    const gifts = [...(this.catalog?.best_deal != null && this.catalog?.best_deal.length > 0 ? this.catalog.best_deal : []), this.catalog?.best_free_shipping].filter(
      (deal): deal is IPriceBookViewDTO => deal !== null
    );

    return gifts;
  }

  getProductGifts(product: IQuotationProduct): IPriceBookViewDTO[] {
    const gifts: IPriceBookViewDTO[] = [];

    const hasDeal = (deal: IPriceBookViewDTO) =>
      gifts.some(d => d.id === deal.id);

    const deals = product.best_deal as IPriceBookViewDTO[] | null;
    if (deals && deals.length > 0) {
      for (const deal of deals) {
        if (!hasDeal(deal)) {
          gifts.push(deal);
        }
      }
    }
    
    const buyXGetYDeal = product.best_buy_x_get_y as IPriceBookViewDTO[] | null;
    if (buyXGetYDeal && buyXGetYDeal.length > 0) {
      for (const deal of buyXGetYDeal) {
        if (!hasDeal(deal)) {
          gifts.push(deal);
        }
      }
    }

    return gifts;
  }

  getTotalColumnsCount(): number {
    // Base columns: checkbox, img, product, brand, retail_price, discount, final_price, markup, quantity, total_amount, stock = 11
    let count = 11;
    
    // Add extra_discount column if enabled
    if (this.catalogMaxExtraDiscount > 0) {
      count += 1;
    }
    
    // In margin mode, replace discount with cost + margin (net +1 column)
    if (this.isMarginOnCost) {
      count += 1;
    }
    
    return count;
  }
}
